import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Badge from "react-bootstrap/Badge";

function ProjectCards(props) {
  return (
    <Card className="project-card-view">
      <Card.Img
        variant="top"
        src={props.imgPath}
        alt={(props.title ? props.title : "Project") + " preview"}
      />
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>{props.description}</Card.Text>

        {Array.isArray(props.techs) && props.techs.length > 0 && (
          <div className="project-badges" style={{ marginBottom: 12 }}>
            {props.techs.map((t, idx) => (
              <Badge key={idx} bg="info" pill style={{ marginRight: 6 }}>
                {t}
              </Badge>
            ))}
          </div>
        )}

        <div className="project-links">
          {props.ghLink && (
            <Button
              variant="primary"
              href={props.ghLink}
              target="_blank"
              rel="noreferrer"
              style={{ marginRight: 10 }}
            >
              Code
            </Button>
          )}
          {props.demoLink && (
            <Button
              variant="outline-info"
              href={props.demoLink}
              target="_blank"
              rel="noreferrer"
            >
              Live
            </Button>
          )}
        </div>
      </Card.Body>
    </Card>
  );
}
export default ProjectCards;
